import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';


export const LibraryHeaderStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    '.view-assessment-def': {
        ".MuiSvgIcon-root": {
            fill: "transparent !important"
        }
    }
}));


export const StatusCellStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    height: 45,
    display: "flex",
    alignItems: "center"
}));

export const AssessmentLibraryStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    flexGrow: 1,
    overflow: "auto",
    display: "flex",
    flexDirection: "column"
}));